
import React from 'react';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-black text-white">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center">
            <h1 className="text-lg md:text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
              株式会社△□○
            </h1>
            <span className="ml-2 md:ml-4 text-sm md:text-lg">総合商事部</span>
          </div>
          <nav className="hidden md:flex space-x-8">
            <a href="#home" className="hover:text-gray-300 transition-colors cursor-pointer">ホーム</a>
            <a href="#services" className="hover:text-gray-300 transition-colors cursor-pointer">事業案内</a>
            <a href="#strengths" className="hover:text-gray-300 transition-colors cursor-pointer">強み</a>
            <a href="#company" className="hover:text-gray-300 transition-colors cursor-pointer">会社案内</a>
            <a href="#contact" className="hover:text-gray-300 transition-colors cursor-pointer">お問い合わせ</a>
          </nav>
          <button className="md:hidden">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="relative h-screen bg-cover bg-center overflow-hidden" style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/60a67d01344d487e9b8344b9e0b6118a.jpg')`
      }}>
        <div className="absolute inset-0 bg-black/70"></div>
        {/* Animated overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-transparent to-black/80 animate-pulse"></div>
        <div className="relative z-10 container mx-auto px-4 h-full flex items-center">
          <div className="w-full max-w-4xl text-white">
            <h2 className="text-5xl md:text-7xl font-bold mb-6 leading-tight animate-fade-in">
              総合商社の原点は<br />
              <span className="text-yellow-400">△□○</span>にあり。
            </h2>
            <p className="text-xl md:text-2xl mb-8 leading-relaxed">
              株式会社△□○総合商事部は、創業50年以上の実績と<br />
              年間850社以上とのネットワークで、お客様の事業成長をサポートします。
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="#services" className="bg-yellow-500 hover:bg-yellow-600 text-black px-8 py-4 rounded-lg font-bold text-lg transition-colors cursor-pointer whitespace-nowrap">
                事業案内を見る
              </a>
              <a href="#contact" className="border-2 border-white hover:bg-white hover:text-black px-8 py-4 rounded-lg font-bold text-lg transition-colors cursor-pointer whitespace-nowrap">
                お問い合わせ
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">事業案内</h2>
            <p className="text-xl text-gray-600">幅広い事業領域でお客様のニーズにお応えします</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* 人材事業 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Young%20Japanese%20woman%20working%20as%20barista%20in%20modern%20cafe%2C%20Asian%20female%20employee%20serving%20coffee%20with%20smile%2C%20professional%20service%20worker%20in%20contemporary%20coffee%20shop%20interior%2C%20friendly%20Japanese%20staff%20member%20in%20cafe%20uniform%20preparing%20drinks&width=400&height=300&seq=13&orientation=landscape')`
              }}></div>
              <div className="p-8">
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-team-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">人材事業</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• 人材派遣事業</li>
                  <li>• 有料職業紹介事業</li>
                  <li>• 外国人雇用事業</li>
                  <li>• 就職斡旋事業（国外大学卒業生対象）</li>
                </ul>
              </div>
            </div>

            {/* 箱型店舗運用代行 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20retail%20shop%20interior%20illustration%20in%20shopping%20mall%2C%20contemporary%20store%20design%20with%20clean%20layout%20and%20product%20displays%2C%20commercial%20facility%20shop%20illustration%20with%20bright%20lighting%20and%20organized%20merchandise%2C%20stylized%20retail%20space%20drawing%20with%20modern%20fixtures&width=400&height=300&seq=21&orientation=landscape')`
              }}></div>
              <div className="p-8">
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-store-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">箱型店舗運用代行</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• PopUp Store運営</li>
                  <li>• My Best shop運営</li>
                  <li>• 常設店舗運営</li>
                </ul>
              </div>
            </div>

            {/* 広告/SNS事業 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Instagram%20logo%20and%20social%20media%20marketing%20graphics%2C%20digital%20marketing%20content%20with%20Instagram%20branding%20and%20social%20media%20icons%2C%20SNS%20advertising%20materials%20with%20Instagram%20interface%20elements%2C%20social%20media%20campaign%20design%20with%20Instagram%20logo%20and%20promotional%20graphics&width=400&height=300&seq=22&orientation=landscape')`
              }}></div>
              <div className="p-8">
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-megaphone-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">広告/SNS事業</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• 国内ピールオフ広告手配</li>
                  <li>• SNS運用代行</li>
                  <li>• ホームページ作成等</li>
                </ul>
              </div>
            </div>

            {/* 教育事業 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Asian%20international%20students%20studying%20abroad%20with%20diverse%20classmates%20in%20university%20classroom%2C%20Japanese%20and%20Asian%20students%20in%20overseas%20university%20environment%20with%20multicultural%20student%20group%2C%20international%20education%20setting%20with%20Asian%20exchange%20students%20learning%20together%20with%20global%20peers&width=400&height=300&seq=23&orientation=landscape')`
              }}></div>
              <div className="p-8">
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-graduation-cap-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">教育事業</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• 英語圏への海外留学</li>
                  <li>• 留学生サポート</li>
                </ul>
              </div>
            </div>

            {/* ロジスティクス事業 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20logistics%20warehouse%20with%20organized%20storage%20systems%20in%20Japan%2C%20professional%20freight%20and%20shipping%20facility%20with%20Japanese%20workers%2C%20contemporary%20distribution%20center%20with%20trucks%20and%20cargo%2C%20efficient%20supply%20chain%20management%20environment%20in%20Japanese%20industrial%20area&width=400&height=300&seq=17&orientation=landscape')`
              }}></div>
              <div className="p-8">
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-truck-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">ロジスティクス事業</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• 輸出入のお手配</li>
                  <li>• 倉庫運用</li>
                  <li>• 物流サポート</li>
                </ul>
              </div>
            </div>

            {/* コンサルティング事業 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Japanese%20business%20consulting%20meeting%20with%20charts%20and%20analytics%20on%20table%2C%20professional%20Asian%20consultants%20analyzing%20data%20and%20graphs%2C%20modern%20office%20consultation%20room%20in%20Japan%2C%20strategic%20business%20planning%20session%20with%20Japanese%20businesspeople%20and%20documents&width=400&height=300&seq=18&orientation=landscape')`
              }}></div>
              <div className="p-8">
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-line-chart-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">コンサルティング事業</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• 売上分析</li>
                  <li>• CPA/CPO最大化</li>
                  <li>• CS/ES/LTV向上施策</li>
                </ul>
              </div>
            </div>

            {/* イベント事業 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow md:col-span-2 lg:col-span-1">
              <div className="h-48 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Daytime%20outdoor%20festival%20event%20in%20Japan%20with%20colorful%20tents%20and%20booths%2C%20Japanese%20community%20festival%20with%20food%20stalls%20and%20entertainment%2C%20bright%20sunny%20day%20outdoor%20event%20with%20families%20and%20visitors%2C%20traditional%20Japanese%20matsuri%20festival%20atmosphere%20with%20modern%20event%20management&width=400&height=300&seq=19&orientation=landscape')`
              }}></div>
              <div className="p-8">
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-calendar-event-line text-3xl text-black"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">イベント事業</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• 創業祭</li>
                  <li>• 各種イベント運用</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Strengths Section */}
      <section id="strengths" className="py-20 bg-black text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20corporate%20background%20with%20geometric%20patterns%2C%20dark%20elegant%20business%20texture%2C%20professional%20company%20backdrop%20with%20subtle%20patterns%2C%20sophisticated%20commercial%20design%20elements&width=1920&height=1080&seq=10&orientation=landscape')`
        }}></div>
        <div className="relative z-10 container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">私たちの強み</h2>
            <p className="text-xl">創業50年以上の実績と信頼</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">創業50年以上の老舗</h3>
              <p className="text-gray-300">長年培った経験と信頼で、安心してお任せいただけます</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-building-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">年間850社以上のネットワーク</h3>
              <p className="text-gray-300">累計9500社以上との豊富な取引実績</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-heart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">一気通貫で丸投げOK</h3>
              <p className="text-gray-300">予算削減も可能な総合的なサポート</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-map-pin-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">日本全国で対応可</h3>
              <p className="text-gray-300">フットワークの軽さが強み</p>
            </div>
          </div>
          
          <div className="text-center mt-16">
            <div className="bg-white/10 rounded-lg p-8 max-w-4xl mx-auto">
              <h3 className="text-3xl font-bold mb-4">どこに頼めばいいかわからないものも</h3>
              <p className="text-xl text-gray-300">ほとんど対応可能です！まずはお気軽にご相談ください。</p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Section */}
      <section id="company" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">会社案内</h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">広島本社</h3>
                  <p className="text-gray-600">〒731-3165 広島県広島市安佐南区伴中央4丁目8-23</p>
                  <p className="text-gray-600">TEL: 082-848-3400</p>
                </div>
                
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">東京オフィス</h3>
                  <p className="text-gray-600">〒100-0005 東京都千代田区丸の内1-1-1</p>
                  <p className="text-gray-600">TEL: 03-1234-5678</p>
                </div>
                
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">大阪オフィス</h3>
                  <p className="text-gray-600">〒530-0001 大阪府大阪市北区梅田1-1-1</p>
                  <p className="text-gray-600">TEL: 06-1234-5678</p>
                </div>
                
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">九州オフィス</h3>
                  <p className="text-gray-600">〒811-2320 福岡県糟屋郡粕屋町内橋東1丁目16-25</p>
                  <p className="text-gray-600">TEL: 092-938-8340</p>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="bg-cover bg-center h-96 rounded-lg mb-6" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20urban%20office%20conference%20room%20with%20glass%20walls%20and%20contemporary%20furniture%2C%20professional%20business%20meeting%20room%20in%20city%20office%20building%2C%20sleek%20corporate%20conference%20space%20with%20modern%20design%20and%20city%20view%2C%20sophisticated%20office%20interior%20with%20meeting%20table%20and%20chairs&width=600&height=400&seq=24&orientation=landscape')`
              }}></div>
              <div className="bg-gray-50 rounded-lg p-8">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">△□○の使命</h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                  私たちは「何の会社なの？」といつも聞かれます。私たちは総合商社として様々な事業を展開している会社です。
                  でも、それ以上に私たちは「しあわせ」を造る会社でありたいと願っています。
                </p>
                <p className="text-gray-600 leading-relaxed">
                  お客様のしあわせが私たちのしあわせです。私たちがしあわせであれば家族や友人もしあわせです。
                  そして、会社に関わる全ての人たちのしあわせを造る・・・△□○はそんな会社を目指しています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gray-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center opacity-10" style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20business%20contact%20background%20with%20communication%20icons%2C%20modern%20corporate%20contact%20page%20design%2C%20elegant%20dark%20business%20texture%20for%20contact%20section&width=1920&height=1080&seq=12&orientation=landscape')`
        }}></div>
        <div className="relative z-10 container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">お問い合わせ</h2>
            <p className="text-xl text-gray-300">お気軽にご相談ください</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16">
            <div>
              <h3 className="text-2xl font-bold mb-6">お電話でのお問い合わせ</h3>
              <div className="space-y-6">
                <div className="bg-gray-800 rounded-lg p-6">
                  <h4 className="text-xl font-bold mb-2">広島本社</h4>
                  <p className="text-3xl font-bold text-yellow-400 mb-2">082-848-3400</p>
                  <p className="text-gray-300">受付時間：平日 9:00-18:00</p>
                  <p className="text-sm text-yellow-300 mt-2">※総合商事部は本社管轄のため、どのエリアからでも本社へまずはご連絡ください</p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold mb-6">メールでのお問い合わせ</h3>
              <form className="space-y-6" data-readdy-form id="contact-form" action="https://readdy.ai/api/form/d42m9cehblhlvkm01fdg" method="POST">
                <input type="hidden" name="email_to" value="nogami@340.co.jp" />
                <div>
                  <label className="block text-sm font-medium mb-2">お名前 *</label>
                  <input 
                    type="text" 
                    name="name"
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-white"
                    placeholder="山田太郎"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-2">会社名</label>
                  <input 
                    type="text" 
                    name="company"
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-white"
                    placeholder="株式会社○○"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-2">メールアドレス *</label>
                  <input 
                    type="email" 
                    name="email"
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-white"
                    placeholder="example@email.com"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-2">お問い合わせ内容 *</label>
                  <select 
                    name="inquiry_type"
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-white pr-8"
                  >
                    <option value="">選択してください</option>
                    <option value="人材事業">人材事業について</option>
                    <option value="店舗運用">箱型店舗運用代行について</option>
                    <option value="広告SNS">広告/SNS事業について</option>
                    <option value="教育事業">教育事業について</option>
                    <option value="ロジスティクス">ロジスティクス事業について</option>
                    <option value="コンサルティング">コンサルティング事業について</option>
                    <option value="イベント">イベント事業について</option>
                    <option value="その他">その他</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-2">メッセージ *</label>
                  <textarea 
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-white resize-none"
                    placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                  ></textarea>
                </div>
                
                <button 
                  type="submit"
                  className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-4 px-8 rounded-lg transition-colors whitespace-nowrap"
                >
                  送信する
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                株式会社△□○
              </h3>
              <p className="text-gray-400 mb-4">総合商事部</p>
              <p className="text-gray-400">
                創業50年以上の実績と信頼で、<br />
                お客様の事業成長をサポートします。
              </p>
            </div>
            
            <div>
              <h4 className="text-lg font-bold mb-4">事業案内</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">人材事業</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">箱型店舗運用代行</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">広告/SNS事業</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">教育事業</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">ロジスティクス事業</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">コンサルティング事業</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">イベント事業</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-bold mb-4">お問い合わせ</h4>
              <div className="space-y-4 text-gray-400">
                <div>
                  <p>TEL: 082-848-3400</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-12 pt-8 text-center">
            <p className="text-gray-400">
              &copy; 2024 株式会社△□○ 総合商事部. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors ml-2 cursor-pointer">Website Builder</a>
            </p>
          </div>
        </div>
      </footer>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 1.5s ease-out;
        }
      `}</style>
    </div>
  );
};

export default HomePage;
